import { getPrefixedUrl } from '@source/utilities/get-prefixed-url';
import { GTMPush } from '@source/utilities/gtm';
import { SubscriptionStoreUser } from '@store/subscription/store.types';
import Environment from '@utilities/environment';
import { sha256 } from '@utilities/sha-256';
import md5 from 'md5';

import { AreaSubscription, DistrictSubscription, NewsletterEndpointModel } from './endpoint-types';

const API_ENDPOINT = '/umbraco/api/ajaxform/submitnewsletterform';

interface SubscribeToNewsletterProps {
    areaInfo: AreaSubscription | DistrictSubscription;
    userInfo: SubscriptionStoreUser;
    fcToken: string;
}

const subscribeToNewsletterApiCall = async ({
    areaInfo,
    userInfo,
    fcToken,
}: SubscribeToNewsletterProps) => {
    const body: NewsletterEndpointModel = {
        FirstName: userInfo.firstName || '',
        LastName: userInfo.lastName,
        LastNamePrefix: userInfo.lastNamePrefix || '',
        Email: userInfo.email,
        AreaId: areaInfo.areaId || '',
        DistrictId: areaInfo.districtId || '',
        FcToken: fcToken,
    };

    if (userInfo.gender) body.IsMale = userInfo.gender === 'Mr';

    if (Environment.isLocal) return;

    const response = await fetch(getPrefixedUrl(API_ENDPOINT), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    });

    if (!response.ok) {
        throw new Error(`Newsletter subscription failed with status ${response.status}.`);
    }
};

export const subscribeToNewsletter = async ({
    areaInfo,
    userInfo,
    fcToken,
}: SubscribeToNewsletterProps) => {
    const { areaProjectName } = window.__ENVIRONMENT_DETAILS__;

    await subscribeToNewsletterApiCall({
        areaInfo,
        userInfo,
        fcToken,
    });

    GTMPush({
        event: 'gtm.NewsletterSubscription',
        eventCategory: 'Newsletter',
        eventAction: 'Subscribe Gebied',
        eventLabel: areaProjectName,
        email: md5(userInfo.email),
        email_sha_256: await sha256(userInfo.email),
    });

    GTMPush({
        event: 'gtm.virtualPageview',
        virtualurl: `${areaProjectName}/newsletter_subscription/aangevraagd`,
        virtualtitle: 'Newsletter Subscription aangevraagd',
    });
};
